import React from 'react'

const ReplaceIcon = () => {
  return (
    <svg
      width="20"
      height="18"
      viewBox="0 0 20 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5 18L0 13L5 8L6.425 9.4L3.825 12H19V14H3.825L6.425 16.6L5 18ZM15 10L13.575 8.6L16.175 6H1V4H16.175L13.575 1.4L15 0L20 5L15 10Z"
        fill="#CCCFD6"
      />
    </svg>
  )
}

export default ReplaceIcon
